module.exports = __webpack_public_path__ + "img/img_body_biz_fire_gwangju_logo.55e9e337.png";